import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useTranslation from 'next-translate/useTranslation';

// Context
import ApproachContext from '../../../../context/ApproachContext';

// Components
import GdprMessage from '../gdprMessage';
import Button from '../../../shared/Button';

// Styles
import styles from './readyStepSection.module.scss';

const ReadyStepSection = ({
  textColor,
  companyColor,
  isButtonDisabled,
  onFunnelOpen,
}) => {
  const approach = useContext(ApproachContext);
  const { t } = useTranslation('common');

  return (
    <>
      <section id="ready-step-section-1" className={styles.containerDesktop}>
        <h2 className={styles.heading}>
          {t(`description_page.ready_step.title.${approach}`)}
        </h2>

        <p className={styles.description}>
          {t(`description_page.ready_step.description.${approach}`)}
        </p>

        <div className={styles.ctaContainer}>
          <div className={styles.button} data-tip data-for="cta-disabled">
            <Button
              data-testid="interested-btn-end-page"
              className="interested-btn"
              style={{
                backgroundColor: companyColor,
                color: textColor,
              }}
              type="default"
              disabled={isButtonDisabled}
              onClick={onFunnelOpen}
            >
              {t(
                `description_page.main_section.cta_btn_interested.${approach}`,
              )}
            </Button>
          </div>
          <GdprMessage className={styles.gdpr} />
        </div>
      </section>

      <section
        id="ready-step-section-2"
        className={styles.containerMobile}
        style={{
          backgroundColor: companyColor,
          color: textColor,
        }}
      >
        <h2 className={styles.heading}>
          {t(`description_page.ready_step.title.${approach}`)}
        </h2>

        <p className={styles.description}>
          {t(`description_page.ready_step.description.${approach}`)}
        </p>

        <div className={styles.ctaContainer}>
          <div className={styles.button} data-tip data-for="cta-disabled">
            <Button
              data-testid="interested-btn-tablet-end-page"
              className="interested-btn"
              style={{
                color: textColor === '#fff' ? companyColor : textColor,
              }}
              type="default"
              disabled={isButtonDisabled}
              onClick={onFunnelOpen}
            >
              {t(
                `description_page.main_section.cta_btn_interested.${approach}`,
              )}
            </Button>
          </div>
          <GdprMessage className={styles.gdpr} />
        </div>
      </section>
    </>
  );
};

ReadyStepSection.propTypes = {
  textColor: PropTypes.string.isRequired,
  companyColor: PropTypes.string.isRequired,
  isButtonDisabled: PropTypes.bool.isRequired,
  onFunnelOpen: PropTypes.func.isRequired,
};

export default ReadyStepSection;
